export default {
    warnings: {
        straightRow: 'キーボードの直線的なキー配列の使用は、推測されやすくなります',
        keyPattern: '短いキーボードパターンは推測されやすくなります',
        simpleRepeat: '"aaa"のような繰り返しの多い文字は推測されやすくなります',
        extendedRepeat: '"abcabcabc"のような繰り返しの多い文字は推測されやすくなります',
        sequences: '”abc”のような一般的な文字は推測されやすくなります',
        recentYears: '最近の西暦は推測されやすくなります',
        dates: '日付は推測されやすくなります',
        topTen: '一般的に使用されるパスワードです',
        topHundred: '頻繁に使われるパスワードです',
        common: 'よく使われるパスワードです',
        similarToCommon: 'よく使われるパスワードに似ています',
        wordByItself: '1つの単語のみは推測されやすくなります',
        namesByThemselves: '1つの名前は推測されやすくなります',
        commonNames: '一般的な名前は推測されやすくなります',
        userInputs: '個人情報やページに関する情報は含めるべきではありません',
        pwned: '過去にインターネット上にパスワードが漏洩しているようです',
    },
    suggestions: {
        l33t: '"a"を"@"に置き換えるような、予測可能な文字の置き換えは避けてください',
        reverseWords: '一般的な単語を逆にした使用は避けてください',
        allUppercase: 'いくつかの文字は大文字にしてください',
        capitalization: '最初の文字以外も大文字にしてください',
        dates: '自分に関連する日付や西暦は避けてください',
        recentYears: '最近の西暦は避けてください',
        associatedYears: '自分に関連のある西暦は避けてください',
        sequences: 'よくある文字列は避けてください',
        repeated: '単語や文字の繰り返しは避けてください',
        longerKeyboardPattern: '長いキーボード配列を使用するまたは、キーボード配列の方向を変えてください',
        anotherWord: '一般的ではない単語を増やしてください',
        useWords: '複数の単語を使用し、よくあるフレーズは避けてください',
        noNeed: '記号や数字、大文字を使わなくても、強力なパスワードを作成することができます',
        pwned: 'このパスワードを他で使用している場合は、変更してください',
    },
    timeEstimation: {
        ltSecond: '秒未満',
        second: '{base} 秒',
        seconds: '{base} 秒',
        minute: '{base} 分',
        minutes: '{base} 分',
        hour: '{base} 時間',
        hours: '{base} 時間',
        day: '{base} 日',
        days: '{base} 日',
        month: '{base} 月',
        months: '{base} 月',
        year: '{base} 年',
        years: '{base} 年',
        centuries: '世紀',
    },
};
//# sourceMappingURL=translations.js.map